import React, { useEffect, useState } from "react";
import { index } from "services/post/PartnershipService";
import { toast } from "react-toastify";
import { get, getCategoriesForPartneship } from "services/CategoryService";
import { InstitutionalResponse, getInstitutional } from "services/PageService";
import { Link, useNavigate } from "react-router-dom";
import placeholder from "images/placeholder-small.png";
import Advertising from "components/ad/Advertising";
import Pagination from "components/table/Pagination";
import NoContent from "components/cards/NoContent";

const PartnersScreen: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingCategories, setLoadingCategories] = useState(true);
  // Adicione a tipagem de any[] para categories
  const [categories, setCategories] = useState<any>([]);
  const [institutional, setInstitutional] =
    useState<InstitutionalResponse | null>(null);

  const [paginationData, setPaginationData] = useState<any>();

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;
  const bannerPath = institutional?.banners?.find(
    (e) => e.name === "Banner inicial"
  )?.banner_path;
  const backgroundImageUrl = `${urlBase}/storage/images/institutional/banners/${bannerPath}`;

  const navigate = useNavigate();

  const fetchCategories = async () => {
    setLoadingCategories(true);
    try {
      const response = await getCategoriesForPartneship();

      setCategories(response);
      setLoadingCategories(false);
    } catch (error) {
      toast.error("Erro ao carregar as categorias");
    }
  };

  const fetchData = async (page = 1) => {
    setLoading(true);
    try {
      const filters = {
        category_id: selectedCategory,
        per_page: 6,
        page: page
      }

      //let filters = selectedCategory ? { category_id: selectedCategory } : {};

      const response = await index(filters);
      setData(response.data);
     
      setPaginationData({
        current_page: response.current_page,
        last_page: response.last_page,
        per_page: response.per_page,
        total: response.total,
      });

      setLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  const fetchInstitutional = async () => {
    try {
      const data = await getInstitutional(5);
      setInstitutional(data);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchInstitutional();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedCategory]);

  const handlePaginationChange = async (page: number) => {
    await fetchData(page);
  };

  return (
    <div className="flex flex-col items-center pt-5 p-1">
      <div
        className={`flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center`}
        style={{ backgroundImage: `url(${backgroundImageUrl})` }}
      >
        <div className="flex-1 flex flex-col h-full rounded-3xl justify-center items-center">
          <span
            className="text-white text-center text-3xl sm:text-4xl lg:text-6xl drop-shadow-md font-semibold"
            style={{ textShadow: "2px 2px 10px rgba(0, 0, 0, 0.5)" }}
          >
            {institutional?.texts?.find((e) => e.name == "Titulo do banner")
              ?.text ?? ""}
          </span>
          <span
            className="text-white text-center mt-4 text-base sm:text-lg lg:text-xl drop-shadow-md font-normal"
            style={{ textShadow: "2px 2px 10px rgba(0, 0, 0, 0.5)" }}
          >
            {institutional?.texts?.find((e) => e.name == "Subtitulo do banner")
              ?.text ?? ""}
          </span>
        </div>
      </div>
      <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
        <Link to={"/"}>Home</Link> &gt;{" "}
        <Link to={"/parceiros"}>Empresas-Parceiras</Link>
      </span>
      {institutional?.videos && institutional?.videos.length > 0 && (
        <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] my-20" >
          <div className="flex flex-col lg:flex-row text-justify items-center gap-10 p-2 bg-primary-50 dark:bg-gray-600 rounded-3xl">
            {/* <div
            
              className="flex w-full text-justify"
              dangerouslySetInnerHTML={{
                __html:
                  institutional?.texts?.find(
                    (e) => e.name == "Descrição parceiros"
                  )?.text ?? "",
              }}
            ></div> */}
            
            <div
              className="flex w-full text-justify"
              dangerouslySetInnerHTML={{
                __html:
                  institutional?.texts?.find((e) => e.name == "Descrição parceiros")
                    ?.text ?? "",
              }}
            ></div>

            <iframe
              className="shadow-2xl w-full sm:w-[30rem] lg:w-[50rem] h-[12rem] sm:h-[17.9rem] rounded-3xl lg:mr-[-10%]"
              width="1980"
              height="1024"
              src={
                institutional?.videos?.find((e) => e.name == "Video parceiros")
                  ?.video_path ?? ""
              }
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
      )}

      <div className="flex sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] mb-20">
        <div className="flex flex-col md:flex-row items-center md:items-start w-full md:px-6 gap-x-20">

          <div className="flex flex-col w-full md:w-96 rounded-3xl bg-neutral-100 dark:bg-neutral-800 shadow-md ">
            
            <div className="flex items-center h-14 px-6 w-full border-2 border-b-0 rounded-t-3xl border-neutral-200 dark:border-neutral-700">
              <span className="w-100 font-center font-bold text-lg text-zinc-700 flex justify-between">
                <span>Categorias</span>
                {/* Botão de limpar filtros */}
                <span
                  className="text-primary-400 cursor-pointer"
                  onClick={() => setSelectedCategory(null)}
                >
                  <small>Limpar filtros</small>
                </span>
              </span>
            </div>
            {categories?.categories &&
              categories?.categories?.map((category: any) => (
                <>
                  <div
                    className={
                      selectedCategory == category.id
                        ? "flex items-center gap-x-4 h-16 px-6 w-full border-2 border-b-0 border-neutral-200 dark:border-neutral-700 bg-gray-200 dark:bg-neutral-700 hover:bg-gray-200 hover:dark:bg-neutral-500 cursor-pointer shadow-inner"
                        : "flex items-center gap-x-4 h-16 px-6 w-full border-2 border-b-0 border-neutral-200 dark:border-neutral-700 hover:bg-gray-300 hover:dark:bg-neutral-500 cursor-pointer"
                    }
                    onClick={() => setSelectedCategory(category.id)}
                  >
                    <img
                      className="w-10 h-10 object-cover rounded-md"
                      src={`${urlBase}/storage/images/categories/icons/${category.icon_path}`}
                      onError={(e) => (e.currentTarget.src = placeholder)}
                    />
                    <div className="flex w-full flex-col justify-center">
                      <span className="font-center font-bold text-zinc-700 dark:text-zinc-300 text-base leading-5 ">
                        {category.name}
                      </span>
                      <span className="font-center font-semibold text-xs text-primary-400 leading-5">
                        {category.subtitle}
                      </span>
                    </div>
                  </div>
                </>
              ))}

            <div className="flex items-center h-14 px-6 w-full border-2 rounded-b-3xl border-neutral-200 dark:border-neutral-700" />
          </div>

          <div className="w-full flex flex-1 mt-8 md:mt-0">
            <div className="w-full flex flex-col items-center gap-y-10">
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 place-items-center gap-y-10 h-fit">
                {
                  !loading ? (
                    <>
                      {data ? (
                        <>
                          {data?.map((item: any) => (
                            <div
                              key={item.id}
                              onClick={() => navigate(`/parceiros/${item.id}`)}
                              className="w-90 flex flex-col w-[1/3] gap-y-2 h-52 mx-2 px-4 items-center justify-center rounded-3xl bg-white dark:bg-gray-600 cursor-pointer hover:bg-primary-50 hover:dark:bg-gray-400"
                            >
                              <div className="flex h-full justify-center items-center mt-4">
                                <img
                                  className="w-20 h-20 object-cover shadow-md rounded-full"
                                  src={
                                    urlBase +
                                    "/storage/images/posts/partnerships/logos/" +
                                    item.logo_path
                                  }
                                  alt="Oferta"
                                  onError={(e) => (e.currentTarget.src = placeholder)}
                                />
                              </div>
                              <div className="flex flex-col h-full items-center justify-between pb-4">
                                <span className="font-bold text-base mb-2 text-center line-clamp-2 leading-6">
                                  {item.title ?? "-"}
                                </span>
                                <span className="font-semibold text-sm text-center text-primary-400 line-clamp-1">
                                  {item.name ?? "-"}
                                </span>
                              </div>
                            </div>
                          ))}
                        </>
                      ) : (
                        <NoContent />
                      )}
                    </>
                  ) : (
                    <>
                    
                    </>
                  )
                }
                  
              </div>

              {
                !loading && data.length > 0 && (
                  <div className="mt-5 flex justify-start">
                    <Pagination pagination={paginationData} fetchData={(page: number) => handlePaginationChange(page)} />
                  </div>
                )
              }
              {/* <button className="w-fit rounded-full bg-primary-900 text-white px-4 py-3 hover:bg-primary-600">
                  Ver mais
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <div className="w-full">
        <div className="mx-4 lg:mx-[16vw] my-10">
          <Advertising type="horizontal" />
        </div>
      </div>
    </div>
  );
};

export default PartnersScreen;
